import { API2_URL, REGISTER_REQUEST, REGISTER_VALIDATE, REGISTER_NOT_VALIDATE, REGISTER_COMPLETE, REGISTER_FAIL} from "../store/config";
import fetch from "isomorphic-fetch";
import _ from "lodash";
import {history} from "../store/store";

export const validateRegister = () => (dispatch) => {
	dispatch(registerRequest(undefined));

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'get'
	}

	return fetch(`${API2_URL}/register`, options)
		.then(result => {
			if (result.status >= 200 && result.status < 300) {
				return result.json();
			} else {
				return result.json().then(Promise.reject.bind(Promise));
			}
		})
		.then(
			json => dispatch(validateRegisterData()),
			error => dispatch(registerFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
		);
}

export const validateEmail = (email) => (dispatch) => {
	dispatch(registerRequest('Validando Email'));

	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'get'
	}

	return fetch(`${API2_URL}/register/email-validation?email=${email}`, options)
		.then(result => {
			if (result.status >= 200 && result.status < 300) {
				return result.json();
			} else {
				return result.json().then(Promise.reject.bind(Promise));
			}
		})
		.then(
			json => {
				if(!_.isEmpty(json.data)){
					return dispatch(registerValidate(json))
				}else {
					return dispatch(registerNotValidate(json, email))
				}
			},
			error => dispatch(registerFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
		);
}

export const registerUser = (values) => (dispatch) => {
	dispatch(registerRequest('Registrando'));
	let body = {
		...values,
		agenciable_id: values.modality_id !== 2 ? values.state_id: values.municipality_id
	}
	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'post',
		body: JSON.stringify(body)
	}

	return fetch(`${API2_URL}/register/user`, options)
		.then(result => {
			if (result.status >= 200 && result.status < 300) {
				return result.json();
			} else {
				return result.json().then(Promise.reject.bind(Promise));
			}
		})
		.then(
			json =>{
				history.push('/');
				return dispatch(registerComplete(json))
			},
			error => dispatch(registerFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
		);
}

export const registerEmail = (values) => (dispatch) => {
	dispatch(registerRequest('Registrando'));
	let body = {
		...values,
		agenciable_id: values.modality_id !== 2 ? values.state_id: values.municipality_id,
		user_id: values.id
	}
	const options = {
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		method: 'post',
		body: JSON.stringify(body)
	}

	return fetch(`${API2_URL}/register/agency`, options)
		.then(result => {
			if (result.status >= 200 && result.status < 300) {
				return result.json();
			} else {
				return result.json().then(Promise.reject.bind(Promise));
			}
		})
		.then(
			json => {
				history.push('/');
				return dispatch(registerComplete(json))
			},
			error => dispatch(registerFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)))
		);
}

const registerRequest = (status) => {
	return {
		type: REGISTER_REQUEST,
		isFetching: true,
		status: status,
		timestamp: Date.now()
	}
}

const registerValidate = (json) => {
	return {
		type: REGISTER_VALIDATE,
		isFetching: false,
		error: undefined,
		status: undefined,
		payload: {
			data: json.data,
			modalities: json.modalities,
			state: 'open',
			action: 'register_validate',
			style: 'is-8'
		},
		timestamp: Date.now()
	}
}

const validateRegisterData = () => {
	return {
		type: REGISTER_VALIDATE,
		isFetching: false,
		error: undefined,
		status: undefined,
		message: undefined,
		payload: {
			data: {validate: true},
			modalities: [],
			state: 'open',
			action: undefined,
			style: 'is-one-third'
		},
		timestamp: Date.now()
	}
}

const registerNotValidate = (json, email) => {
	return {
		type: REGISTER_NOT_VALIDATE,
		isFetching: false,
		error: undefined,
		status: undefined,
		message: undefined,
		payload: {
			data: {email: email},
			modalities: json.modalities,
			state: 'open',
			action: 'register_not_validate',
			style: 'is-10'
		},
		timestamp: Date.now()
	}
}

const registerComplete = (json) => {
	return {
		type: REGISTER_COMPLETE,
		error: undefined,
		status: undefined,
		message: json.message,
		isFetching: false,
		payload: {
			data: {},
			modalities: [],
			state: 'open',
			action: undefined,
			style: 'is-one-third'
		},
		timestamp: Date.now()
	}
}

const registerFail = (error) => {
	return {
		type: REGISTER_FAIL,
		isFetching: false,
		status: undefined,
		message: undefined,
		error: error,
		timestamp: Date.now()
	}
}


// WEBPACK FOOTER //
// ./src/actions/register.js